import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';

// Hydrate initial state from server
declare global {
  interface Window {
    __INITIAL_STATE__?: {
      auth?: {
        user: any;
      };
      profile?: any;
      error?: string;
    };
  }
}

const initialState = window.__INITIAL_STATE__;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider initialUser={initialState?.auth?.user}>
      <App />
    </AuthProvider>
  </StrictMode>
);
